import React from "react";
import ServiceRequest from "./ServiceRequest";
import { AlertCircle } from "react-feather";

export default function ServiceRequestList({ serviceRequestList, ...props }) {
  const renderList = () => {
    const view = Object.entries(serviceRequestList).map(([key, value], i) => {
      const customer = {
        email: key,
        phone: value[0] ? value[0].sContactNumber : "",
        firstName: value[0] ? value[0].sFirstName : "",
        lastName: value[0] ? value[0].sLastName : "",
      };
      return (
        <div className="col-4 form-group" key={i} ref={props.bottomRef}>
          <ServiceRequest
            customer={customer}
            requests={value}
            onServiceRequestClick={props.onServiceRequestClick}
            onUserProfileClick={props.onUserProfileClick}
            handleClickPackage={props.handleClickPackage}
            serviceRequestList={serviceRequestList}
          />
        </div>
      );
    });
    if (view.length === 0) {
      return (
        <div className="ml30 flex align-items-center bg-white p-3 rounded conv-width-40p">
          <AlertCircle />
          <span className="ml-2">
            There are no service requests assigned to you at the moment.
          </span>
        </div>
      );
    }
    return view;
  };
  return (
            <div className="col-12 conv-bg-F2F2F2 min-vh-100 conv-width-100p conv-pt120">
              <div className="row">
                  {renderList()}
              </div>
           </div>
         );
}
